// extracted by mini-css-extract-plugin
export default {"checkbox-with-tooltip-container":"c0t8kP","can-access-quicksight-console-checkbox":"MDTJ0U","tooltip-container":"uvq8dT","tooltip-icon":"RG4OMv"};